import { createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-13b02520")

_pushScopeId("data-v-13b02520")
const _hoisted_1 = { class: "iframe" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _directive_loading = _resolveDirective("loading")

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("iframe", {
      ref: "iframeRef",
      frameborder: "0",
      src: _ctx.herf,
      width: "100%",
      height: "100%",
      sandbox: "allow-scripts allow-same-origin",
      onLoad: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onIframeLoaded && _ctx.onIframeLoaded(...args)))
    }, null, 40, ["src"])
  ], 512)), [
    [_directive_loading, _ctx.loading]
  ])
})